'use strict';

module.exports = /*@ngInject*/ function($scope) {
	// var vm = this;

};